<template lang="pug">
    div
        status-component.statusExpired.userStatus(v-if="status === 'expired'") expired
        status-component.statusExpired.userStatus(v-if="status === 'deactivated'") deactivated
        status-component.statusTrial.userStatus(v-if="status === 'trial'") trial
        status-component.statusMonthly.userStatus(v-if="status === 'monthly'") monthly
        status-component.statusAnnual.userStatus(v-if="status === 'annual'") annual
        status-component.statusGympass.userStatus(v-if="status === 'discontinued'") discontinued
        status-component.statusGympass.userStatus(v-if="status === 'gympass'") gympass
        status-component.statusGympass.userStatus(v-if="status === 'corporate'") {{ isChampion ? 'active' : 'corporate' }}
        status-component.statusGympass.userStatus(v-if="status === 'incomplete'") incomplete
        status-component.statusGympass.userStatus(v-if="status === 'unregistered'") unregistered

</template>

<script>
    import VueTypes from 'vue-types';
    import Status from '~components/Status';
    import { mapGetters } from 'vuex';

    export default {
        components: {
            StatusComponent: Status
        },
        props: {
            status: VueTypes.string.def('')
        },
        computed: {
            ...mapGetters('auth', ['isChampion'])
        }
    };
</script>
